import { httpUtil } from './httpUtil'
import { ErrorCodes, createResult, createCommonResult } from './resultUtil'

export const printout = {
    printInvoice
}

async function printInvoice(invoiceID) {
    try {
        const templateId = await getTemplate();
        if (templateId) {
            const result = await httpUtil.post({
                resourcePath: "/v1/printout",
                isBackend: true,
                logOutIfSessionInvalid:false,
                returnText: true,
                body: {
                    entity: {
                        name: "INVOICE",
                        id:invoiceID
                    },
                    template_id: templateId,
                    action: "WEB_VIEW"
                }
            })
            return createCommonResult(result);
        } return createResult(ErrorCodes.UNKNOWN);
    } catch (ex) {
        return createResult(ErrorCodes.UNKNOWN, ex);
    }
}

async function getTemplate() {
    let templateId = null;
    try {
        const result = await httpUtil.get({
            resourcePath: "/v1/communication_templates",
            isBackend: true,
            logOutIfSessionInvalid:false,
            queryParams: {
                entity: "INVOICE",
                channel: "EMAIL",
                name: "Invoice"
            }
        })
        if (result.code == 'OK' && result.data.content && result.data.content.length > 0) {
            templateId = result.data.content[0].id;
        }
    } catch (ex) {
        console.log("getListTemplate ex:", ex);
    }
    return templateId;
}
